<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="750px"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <div class="adddres-box">
      <el-form label-width="110px" :model="addressData" :rules="rules">
        <el-form-item label="地址信息：" prop="province">
          <el-select
            v-model="addressData.ProvinceName"
            placeholder="省"
            @change="handleProvince"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="addressData.CityName"
            placeholder="市"
            @change="handleCity"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in cityList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="addressData.CountyName"
            placeholder="区"
            @change="handleArea"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in areaList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            v-model="addressData.TownName"
            placeholder="街道"
            @change="handleTown"
            style="width: 150px;"
            value-key="Id"
          >
            <el-option
              v-for="item in townList"
              :key="item.Id"
              :label="item.AreaName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址：" prop="Address">
          <el-input type="textarea" v-model="addressData.Address"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码：">
          <el-input v-model="addressData.Zip"></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名：" prop="Receiver">
          <el-input v-model="addressData.Receiver"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="Phone">
          <el-input v-model="addressData.Phone"></el-input>
        </el-form-item>
        <el-form-item label="电话号码：">
          <el-input></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="addressData.IsDefault">设置为默认收货地址</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addAddressFun">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import {
  AreaList,
  AddressAdd,
  // AddressDelete,
  AddressUpdate
} from '../api/api'
export default {
  props: {
    title: {
      type: String,
      default: '新增收货地址'
    },
    dataAddress: {
      type: Object,
      default(){

      }
    }
  },
  data(){
    return{
      provinceList: [],
      cityList: [],
      areaList: [],
      townList: [],
      province: null,
      city: null,
      county: null,
      town: null,
      rules: {
        province: [{required: true, message: '请选择省/市/区/街道', trigger: 'blur'}],
        Address: [{required: true, message: '请填写详情地址', trigger: 'blur'}],
        Receiver: [{required: true, message: '请填写收货人姓名', trigger: 'blur'}],
        Phone: [{required: true, message: '请填写收货手机号', trigger: 'blur'}],
      },
      addressData: {
        IsDefault: false,
        Receiver: '',
        Phone: '',
        Zip: '',
        ProvinceId: null,
        ProvinceName: '',
        CityId: null,
        CityName: '',
        CountyId: null,
        CountyName: '',
        TownId: null,
        TownName: '',
        Address: ''
      }
    }
  },
  created(){
    this.getProvinceList()
    if(this.dataAddress.Id){
      this.addressData = this.dataAddress

    }
  },
  methods:{
    handleClose(){
      this.$emit('closeFun', false)
    },
    updateFun(){
      this.$emit('updateFun')
      console.log('11111111111111111111111')
    },
    addAddressFun(){
      console.log(this.addressData,'pppppppppppppp')
      if(this.addressData.Id){
        AddressUpdate(this.addressData).then(res =>{
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.updateFun()
            this.handleClose()
          } else{
            this.$message.error(res.data.msg)
          }
        })
      } else{
        AddressAdd(this.addressData).then(res =>{
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.updateFun()
            this.handleClose()
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    getProvinceList(){
      let params = {
        areaLevel: 1
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.provinceList = res.data.response.data;
          if (this.addressData.ProvinceId) {
            this.getCityList();
          }
        }
      })
    },
    getCityList(){
      let params = {
        parentId: this.addressData.ProvinceId
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.cityList = res.data.response.data;
          if (this.addressData.CityId) {
            this.getAreaList();
          }
        }
      })
    },
    getAreaList(){
      let params = {
        parentId: this.addressData.CityId
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.areaList = res.data.response.data;
          if (this.addressData.CountyId) {
            this.getTownList();
          }
        }
      })
    },
    getTownList(){
      let params = {
        parentId: this.addressData.CountyId
      }
      AreaList(params).then(res =>{
        if(res.data.success){
          this.townList = res.data.response.data;
          // if (this.ProvinceId) {
          //   this.getAreaList();
          // }
        }
      })
    },
    handleProvince(val){
      this.addressData.ProvinceId = val.Id
      this.addressData.ProvinceName = val.AreaName
      this.addressData.CityId = null
      this.addressData.CityName = ''
      this.addressData.CountyId = null
      this.addressData.CountyName = ''
      this.addressData.TownId = null
      this.addressData.TownName = ''
      this.getCityList()
    },
    handleCity(val){
      this.addressData.CityId = val.Id
      this.addressData.CityName = val.AreaName
      this.addressData.CountyId = null
      this.addressData.CountyName = ''
      this.addressData.TownId = null
      this.addressData.TownName = ''
      this.getAreaList()
    },
    handleArea(val){
      this.addressData.CountyId = val.Id
      this.addressData.CountyName = val.AreaName
      this.addressData.TownId = null
      this.addressData.TownName = ''
      this.getTownList()
    },
    handleTown(val){
      this.addressData.TownId = val.Id
      this.addressData.TownName = val.AreaName
    }
  },
}
</script>
<style scoped>
.el-textarea{
  width: 500px;
}
.el-input{
  width: 400px;
}
</style>